import { RotateCcw, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Cover } from "./Cover";
import { errMsg, http } from "../lib/api";

const KEEP_DAYS = 30;
const daysLeft = (iso) => {
  const t = new Date(iso).getTime();
  return Number.isFinite(t) ? Math.max(0, KEEP_DAYS - Math.floor((Date.now() - t) / 86400000)) : KEEP_DAYS;
};

const TrashRow = ({ song, onRestore, onDelete }) => (
  <div data-testid={`trash-row-${song.id}`} className="flex items-center gap-4 p-3 rounded-2xl hover:bg-[var(--c-surface)] transition-colors">
    <Cover song={song} className="w-12 h-12 rounded-xl shrink-0 opacity-70" />
    <div className="min-w-0 flex-1">
      <p className="font-semibold truncate">{song.title || "Be pavadinimo"}</p>
      <p className="text-xs text-zinc-500 truncate">
        Ištrinta {new Date(song.deleted_at).toLocaleDateString("lt-LT")} · bus pašalinta po {daysLeft(song.deleted_at)} d.
      </p>
    </div>
    <button data-testid={`trash-restore-${song.id}`} onClick={() => onRestore(song)}
      className="flex items-center gap-1.5 px-4 py-2 rounded-full border border-[var(--c-line)] text-sm hover:border-white transition-colors">
      <RotateCcw className="w-4 h-4" /><span className="hidden sm:inline">Atkurti</span>
    </button>
    <button data-testid={`trash-delete-${song.id}`} onClick={() => onDelete(song)} title="Ištrinti visam laikui"
      className="p-2 rounded-lg text-zinc-500 hover:text-red-400 hover:bg-red-500/10 transition-colors"><Trash2 className="w-4 h-4" /></button>
  </div>
);

export const TrashList = ({ songs, reload }) => {
  const run = async (fn, msg) => {
    try { await fn(); toast.success(msg); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  const restore = (s) => run(() => http.post(`/songs/${s.id}/restore`), "Daina atkurta");
  const remove = (s) => window.confirm(`Ištrinti „${s.title}“ visam laikui? To atšaukti nebus galima.`)
    && run(() => http.delete(`/songs/${s.id}/permanent`), "Daina ištrinta visam laikui");
  const empty = () => window.confirm("Ištrinti visas šiukšliadėžės dainas visam laikui?")
    && run(() => http.delete("/songs/trash"), "Šiukšliadėžė išvalyta");

  return (
    <section data-testid="trash-list" className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3 p-4 rounded-2xl bg-[var(--c-surface)] border border-[var(--c-line)]">
        <p className="text-sm text-zinc-400">Ištrintos dainos čia laikomos {KEEP_DAYS} dienų, po to pašalinamos automatiškai.</p>
        {songs.length > 0 && (
          <button data-testid="trash-empty-button" onClick={empty}
            className="px-4 py-2 rounded-full text-sm text-red-400 border border-red-500/30 hover:bg-red-500/10 transition-colors">Išvalyti šiukšliadėžę</button>
        )}
      </div>
      {songs.length === 0 && <p data-testid="trash-empty" className="text-center py-16 text-zinc-500">Šiukšliadėžė tuščia.</p>}
      <div className="space-y-1">
        {songs.map((s) => <TrashRow key={s.id} song={s} onRestore={restore} onDelete={remove} />)}
      </div>
    </section>
  );
};
